import React, { useEffect, useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { AuthenticatedPUTRequest } from '../../../../utils';

const SetClassSectionModal = (props) => {
    const { id, sections, open, onClose, onError } = props;
    const [update_student_class_and_section, set_student_class_and_section] = useState({
        class_room_id: '',
        section_id: '',
    });
    const [loading, setLoading] = useState(false);

    const updateStudent = async () => {
        setLoading(true);
        try {
            const { success } = await AuthenticatedPUTRequest(`students/${id}`, {
                student: update_student_class_and_section,
            });
            if (!success) {
                onError('مہرنانی، کچھ غلط ہو گیا ہے۔ دوبارہ کوشش کریں۔');
                setLoading(false);
                onClose();
            } else {
                setLoading(false);
                onClose();
                window.location.reload();
            }
        } catch (error) {
            setLoading(false);
            onError('براہ کرم دوبارہ کوشش کریں۔');
        }
    };

    useEffect(() => {
        if (sections) {
            let initial_section = sections[0];
            set_student_class_and_section({
                class_room_id: initial_section['class_room_id'],
                section_id: initial_section['id'],
            });
        }
    }, [sections]);

    return open ? (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 300,
                    maxHeight: 300,
                    width: 576,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            طالب علم کی کلاس کا سیکشن منتخب کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20, height: 'calc(100% - 156px)' }}
                    >
                        <div className='form-container'>
                            <label htmlFor='class_section'>
                                طالب علم کی کلاس کا سیکشن منتخب کریں
                                <span className='required'>*</span>
                            </label>

                            <select
                                name='class_section'
                                style={{ fontSize: 20, padding: 8 }}
                                onChange={(event) =>
                                    set_student_class_and_section({
                                        ...update_student_class_and_section,
                                        section_id: event.target.value,
                                    })
                                }
                            >
                                {props.sections &&
                                    props.sections.map((item, index) => (
                                        <option value={item.id} key={index + 1}>
                                            {item.name['urdu']}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </div>

                    <div
                        className='flex justifyEnd alignCenter w-100'
                        style={{ height: 64, paddingLeft: 16 }}
                    >
                        <div className='flex justifyBetween alignCenter'>
                            <div
                                className='flex justifyEnd alignCenter register_button'
                                style={{ margin: '0 8px' }}
                                onClick={() => updateStudent()}
                            >
                                {loading ? (
                                    <div className='custom_loader' />
                                ) : (
                                    <h3>{`محفوظ کریں`}</h3>
                                )}
                            </div>
                            <div
                                className='flex justifyEnd alignCenter delete_button'
                                style={{ margin: '0 8px' }}
                                onClick={props.onClose}
                            >
                                <h3>{`منسوخ کریں`}</h3>
                            </div>
                        </div>
                    </div>

                    {/* {error !== "" && (
                        <div className="error-toast w-100"
                            style={{
                                padding: "12px 16px 8px",
                                width: "100%",
                                textAlign: "center",
                                position: "absolute",
                                bottom: 0
                            }}>
                            <p style={{ color: "#ffffff" }}> {error}</p>
                        </div>
                    )} */}
                </div>
            </div>
        </div>
    ) : null;
};

export default SetClassSectionModal;
